<script setup lang='ts'>
import { APP_ROUTER } from '@qctsw/common'
import { logicAuthorCorrelationRank } from '@/logic/rank/authorCorrelation'

const props = withDefaults(defineProps<{
  embedded?: boolean
}>(), {
  embedded: true,
})

const {
  state,
  data,
  getRankData,
} = logicAuthorCorrelationRank()

await getRankData()
</script>

<template>
  <n-card
    title="相关资讯" :embedded="props.embedded" size="small"
    class="rounded-md"
    header-style="--n-title-font-weight: bold; --n-padding-bottom: 0.25rem"
  >
    <UtilLoadState :state="state" :reload-handler="getRankData">
      <template v-if="data && data.length">
        <NuxtLink
          v-for="(v, i) in data" :key="i"
          class="mb-1 text-4.25 last:mb-0 line-clamp-1 hover:text-orange-6"
          :to="APP_ROUTER.newsDetail(v.id)"
        >
          {{ v.title }}
        </NuxtLink>
      </template>
      <BasicEmpty v-else />
    </UtilLoadState>
  </n-card>
</template>

<style lang='scss' scoped>
</style>
